import React, { Component } from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import axios from '../util/axios';
import AlertMessage from './common/alertMessage';
import Button from './common/Button';

class ApplicantModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
            btnLoading: false,
            btnLoadingResubmit: false,
            success: null,
            error: null
        };
    }

    refresh = () => {
        let flToken = this.props.applicant ? this.props.applicant.flToken : null;
        let cobrandName = this.props.cobrand ? this.props.cobrand.application : null;
        axios.post('/api/application/refresh', {}, {
            headers: {
                "Authorization": `Bearer ${flToken}`,
                "Cobrand-Name": cobrandName
            }
        })
        .then(res => {
            this.setState({ btnLoading: false, success: 'Success, the refresh process has started for this application', error: false });
            this.props.handleCloseApplicantModal();
        })
        .catch(err => {
            this.setState({ btnLoading: false, error: 'Error, application was not refreshed. Please try again and if this issue continues contact Yodlee Customer Care.', success: false });
        })
    }

    resubmit = () => {
        let applicantId = this.props.applicant ? this.props.applicant.id : null;
        let cobrandId = this.props.cobrand ? this.props.cobrand.id : null;
        axios.put(`/api/applicant/resubmit/${applicantId}`, {}, {
            headers: {
                "Authorization": this.props.userToken,
                "Cobrand-Id": cobrandId
            }
        })
        .then(res => {
            this.setState({ btnLoadingResubmit: false, success: 'Success, this applicant has been instructed to resubmit their application', error: false });
            this.props.handleCloseApplicantModal();
        })
        .catch(err => {
            this.setState({ btnLoadingResubmit: false, error: 'Error, your e-mail was not sent. Please try again and if this issue continues contact Yodlee Customer Care.', success: false });
        })
    }

    toggleLoading = () => {
        this.setState({ btnLoading: true });
    }

    toggleLoadingResubmit = () => {
        this.setState({ btnLoadingResubmit: true });
    }

    sendNotification = (type, to) => {
        axios.post('/api/user/notify', {
                type,
                to
            }, {
            headers: {
                "Authorization": this.props.userToken,
                "Cobrand-Id": this.props.cobrandId
            }
        })
        .then(res => {
            this.setState({ btnLoading: false, success: true, error: false });
            this.props.updateApplicantData();
            this.props.handleCloseApplicantModal();
        })
        .catch(err => {
            this.setState({ btnLoading: false, error: 'Error, your e-mail was not sent. Please try again and if this issue continues contact Yodlee Customer Care.', success: false });
            console.log(err);
        })
    }

    render() {
        return (
            <div style={{ margin: 10 }}>
                <Modal
                    isOpen={true}
                    contentLabel="onRequestClose Example"
                    onRequestClose={this.props.handleCloseApplicantModal}
                    className={ this.props.className || "Applicant-Modal" }
                    overlayClassName="Overlay"
                >
                    <div className="Applicant-Modal-Inner">
                        { this.props.modalType === 'refresh' &&
                            <React.Fragment>
                                <h4>Application ID: { this.props.application.id }</h4>
                                <div className="row mt-4">
                                    <div className="col">
                                        <h5>Refresh Application</h5>
                                        <p>
                                            Last Updated: { moment
                                                            .utc(this.props.application.completionDate)
                                                            .local()
                                                            .format("MM-DD-YYYY HH:mm")
                                                           }
                                        </p>
                                        <p>If you would like to get the applicant's latest financial data for this application, or fix an application which is in an error state, please click the below button to trigger a refresh. The applicant will not be notified of this action.</p>
                                        <Button
                                            text="Refresh Application"
                                            loading={this.state.btnLoading}
                                            onClick={() => { this.toggleLoading(); this.refresh() } }
                                        />
                                    </div>
                                    <div className="col" style={{ borderLeft: '1px solid #6c757d' }}>
                                        <div className="ml-2">
                                            <h5>Request Resubmission</h5>
                                            <p>Last Notified: { moment
                                                        .utc(this.props.applicant.snapshotReqAsOf)
                                                        .local()
                                                        .format("MM-DD-YYYY HH:mm")
                                                    }
                                            </p>
                                            <p>If you would like this applicant to link more accounts and/or resubmit their application, please click the below button. An e-mail will be sent to the applicant which will instruct them to submit a new application.</p>
                                            <Button
                                                text="Request Resubmission"
                                                loading={this.state.btnLoadingResubmit}
                                                onClick={() => { this.toggleLoadingResubmit(); this.resubmit() } }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4" style={{ marginLeft: '-35px' }}>
                                    { this.state.error && <AlertMessage message={this.state.error} alertType={'alert-danger'}/> }
                                </div>
                            </React.Fragment>
                        }
                        { this.props.modalType === 'reminder' &&
                            <React.Fragment>
                                <h4>Send Reminder</h4>
                                <p>
                                    Applicant: { this.props.applicant.username }<br />
                                    Last Notified: { moment
                                                        .utc(this.props.applicant.snapshotReqAsOf)
                                                        .local()
                                                        .format("MM-DD-YYYY HH:mm")
                                                    }
                                </p>
                                <p>If you would like to remind this applicant to submit their application, please click the below button and a reminder e-mail will be sent to them.</p>
                                <Button 
                                    text="Send Reminder"
                                    loading={this.state.btnLoading}
                                    onClick={() => { this.toggleLoading(); this.sendNotification(this.props.modalType, this.props.applicant.username) } }
                                />
                                <button type="button" className="btn btn-secondary ml-2" onClick={() => { this.props.handleCloseApplicantModal() } }>
                                    Cancel
                                </button>
                                <div className="mt-4" style={{ marginLeft: '-35px' }}>
                                    { this.state.error && <AlertMessage message={this.state.error} alertType={'alert-danger'}/> }
                                </div>
                            </React.Fragment>
                        }
                        { this.props.modalType === 'resubmitReminder' &&
                            <React.Fragment>
                                <h4>Send Resubmit Reminder</h4>
                                <p>
                                    Applicant: { this.props.applicant.username }<br />
                                    Last Notified: { moment
                                                        .utc(this.props.applicant.snapshotReqAsOf)
                                                        .local()
                                                        .format("MM-DD-YYYY HH:mm")
                                                    }
                                </p>
                                <p>If you would like to remind this applicant to resubmit their application, please click the below button and a reminder e-mail will be sent to them.</p>
                                <Button 
                                    text="Send Reminder"
                                    loading={this.state.btnLoading}
                                    onClick={() => { this.toggleLoading(); this.sendNotification(this.props.modalType, this.props.applicant.username) } }
                                />
                                <button type="button" className="btn btn-secondary ml-2" onClick={() => { this.props.handleCloseApplicantModal() } }>
                                    Cancel
                                </button>
                                <div className="mt-4" style={{ marginLeft: '-35px' }}>
                                    { this.state.error && <AlertMessage message={this.state.error} alertType={'alert-danger'}/> }
                                </div>
                            </React.Fragment>
                        }
                    </div>
                    <button className="close customPos" onClick={this.props.handleCloseApplicantModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal>
            </div>
        );
    }
}

export default ApplicantModal;
